











import Vue from "vue";

interface Data {
  activeTab: number | string | null;
}

interface Method{
  setTab(value: number): void;
}

interface Props{
  defaultTab: number;
}
export default Vue.extend<Data,Method,{},Props>({
  props: {
    defaultTab: Number,
  },

  beforeMount() {
    if (this.defaultTab) this.activeTab = this.defaultTab;
  },

  data() {
    return {
      activeTab: null,
    }
  },
  methods:{
    setTab(value) {
      this.activeTab = value;
    },
  }
});
